import http from '@/utils/http'
import convert from '@/utils/model-convert'
import { FeedbackSearchArgument } from '@/models/resource-count'

const URL = '/rest/customer/feedback/resourceCount'
const ITEM_URL = '/rest/customer/platform/items/all'

export default {
  itemTitle ({search}, cb) {
    http.get(ITEM_URL, {
      params: convert.toJson(search, FeedbackSearchArgument)
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  list ({search}, cb) {
    http.get(URL, {
      params: convert.toJson(search, FeedbackSearchArgument)
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  }
}



// WEBPACK FOOTER //
// ./src/api/client/resource-count.js